import { studyQueryKeys } from '@/config/queryKeys';
import { getSelectedOrg } from '@/helpers';
import { fetchStudy } from '@/services/studies';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/studies/$studyId_/broadscale-samples')({
  loader: ({ context: { queryClient }, params: { studyId } }) => {
    const selectedOrg = getSelectedOrg();
    if (!selectedOrg?.id) throw redirect({ to: '/organizations' });
    return queryClient.ensureQueryData({
      queryKey: studyQueryKeys.detail(selectedOrg.id, studyId),
      queryFn: () => fetchStudy(selectedOrg.id, studyId),
    });
  },
});
